import { Route, Navigate, Routes } from "react-router-dom";

import ForgotPassword from "containers/ForgotPassword";
import SignIn from "containers/SignIn";
import SignUp from "containers/SignUp";

function PublicRoutes() {
  return (
    <Routes>
      <Route path='/sign-up' element={<SignUp />} />
      <Route path='/forgot-password' element={<ForgotPassword />} />
      <Route path='/' element={<SignIn />} />
      <Route element={<Navigate to='/' replace />} />
    </Routes>
  );
}

export default PublicRoutes;
